// CapTable.js

import React, { useState, useEffect } from 'react';
import { XMarkIcon, PlusIcon } from '@heroicons/react/24/outline';

function CapTable({ name, label, value, onChange }) {
  const [owners, setOwners] = useState(value && value.length > 0 ? value : [{ name: '', percentage: '' }]);

  const handleAddOwner = () => {
    setOwners([...owners, { name: '', percentage: '' }]);
  };

  const handleRemoveOwner = (index) => {
    if (owners.length > 1) {
      setOwners(owners.filter((_, i) => i !== index));
    }
  };

  const handleOwnerChange = (e, index) => {
    const { name, value } = e.target;
    setOwners(owners.map((owner, i) => (i === index ? { ...owner, [name]: value } : owner)));
  };

  const calculatePG = (owners) => owners.filter((owner) => parseFloat(owner.percentage) > 20).length;

  const totalPercentage = owners.reduce((sum, owner) => sum + (parseFloat(owner.percentage) || 0), 0);
  const isValid = Math.abs(totalPercentage - 100) < 0.01;

  useEffect(() => {
    onChange(owners, calculatePG(owners));
  }, [owners]);

  return (
    <div className="space-y-2">
      {owners.map((owner, index) => (
        <div key={index} className="flex items-center gap-2">
          <input
            type="text"
            name="name"
            value={owner.name}
            onChange={(e) => handleOwnerChange(e, index)}
            placeholder="Owner name"
            className="flex-1 min-w-0 border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
          />
          <div className="relative w-24 flex-shrink-0">
            <input
              type="number"
              name="percentage"
              value={owner.percentage}
              onChange={(e) => handleOwnerChange(e, index)}
              placeholder="0"
              min="0"
              max="100"
              step="0.01"
              className="w-full pl-3 pr-7 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
            />
            <span className="absolute right-3 top-1/2 -translate-y-1/2 text-sm text-gray-400 pointer-events-none">%</span>
          </div>
          <button
            type="button"
            onClick={() => handleRemoveOwner(index)}
            disabled={owners.length <= 1}
            title="Remove owner"
            className="p-2 rounded-md text-gray-400 hover:text-red-600 hover:bg-red-50 disabled:opacity-30 disabled:cursor-not-allowed"
          >
            <XMarkIcon className="h-4 w-4" />
          </button>
        </div>
      ))}

      <button
        type="button"
        onClick={handleAddOwner}
        className="inline-flex items-center gap-1 text-xs font-medium text-indigo-600 hover:text-indigo-700"
      >
        <PlusIcon className="h-4 w-4" />
        Add owner
      </button>

      <div className="flex items-center justify-between pt-3 mt-3 border-t border-gray-200">
        <span className="text-xs font-medium text-gray-600">Total</span>
        <span className={`text-sm font-semibold ${isValid ? 'text-emerald-600' : 'text-orange-600'}`}>
          {totalPercentage.toFixed(2)}%
          {!isValid && <span className="ml-2 text-xs font-normal text-orange-500">(must equal 100%)</span>}
        </span>
      </div>
    </div>
  );
}

export default CapTable;
